import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useCategoryTreeItem } from '../categoryTree';
import { tvpil } from '../compat/tvpil';

import { getTopXWatched } from './getTopXWatched';
import { createMostWatchedQueryOptions } from './queryOptions';

type UseMostWatchedProps = {
  referenceId: string;
};

export function useMostWatched({ referenceId }: UseMostWatchedProps) {
  const category = useCategoryTreeItem(referenceId);

  const isEnabled = Boolean(category && tvpil.userId);

  const { data: watchStats, isLoading } = useQuery({
    ...createMostWatchedQueryOptions({ userId: tvpil.userId! }),
    enabled: isEnabled,
  });

  const mostWatched = useMemo(() => {
    if (!watchStats || !category?.mostWatched) {
      return undefined;
    }

    const { mostWatched } = category;

    return getTopXWatched({
      watchStats,
      watchPeriod: mostWatched.presentMostWatchedPeriod,
      topX: mostWatched.presentMostWatchedCount,
    });
  }, [watchStats, category]);

  return { mostWatched, isLoading };
}
